module.exports = "/call-frontend/img/icon_star_inactive.2c4bcbfd.svg";